import { render, staticRenderFns } from "./team_edit.vue?vue&type=template&id=83c35b4a&"
import script from "./team_edit.vue?vue&type=script&lang=js&"
export * from "./team_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports